var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { css } from 'styled-components';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
export var Animation = function Animation(_a) {
  var children = _a.children,
      animation = _a.animation,
      props = __rest(_a, ["children", "animation"]);

  var opts = {
    appear: true,
    classNames: animation,
    timeout: {
      enter: 200,
      exit: 200
    }
  }; // Allow overriding from implementation

  opts = __assign(__assign({}, opts), props);
  return React.createElement(CSSTransition, opts, children);
}; // TODO: Literally no idea why this and Animation behave so ridiculously different...

export var AnimationGroup = function AnimationGroup(_a) {
  var children = _a.children,
      animation = _a.animation,
      props = __rest(_a, ["children", "animation"]);

  var opts = {
    appear: true,
    classNames: animation,
    timeout: {
      enter: 200,
      exit: 200
    }
  }; // Allow overriding from implementation

  opts = __assign(__assign({}, opts), props);
  return React.createElement(TransitionGroup, {
    component: null
  }, React.createElement(CSSTransition, opts, children));
};
export var fade = function fade() {
  return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.fade-enter,\n  &.fade-appear {\n    opacity: 0.01;\n  }\n\n  &.fade-enter-done,\n  &.fade-appear-done,\n  &.fade-enter.fade-enter-active,\n  &.fade-appear.fade-appear-active {\n    opacity: 1;\n    transition: opacity 200ms ease-in;\n  }\n\n  &.fade-exit {\n    opacity: 1;\n  }\n\n  &.fade-exit-done,\n  &.fade-exit.fade-exit-active {\n    opacity: 0.01;\n    transition: opacity 200ms ease-out;\n  }\n"], ["\n  &.fade-enter,\n  &.fade-appear {\n    opacity: 0.01;\n  }\n\n  &.fade-enter-done,\n  &.fade-appear-done,\n  &.fade-enter.fade-enter-active,\n  &.fade-appear.fade-appear-active {\n    opacity: 1;\n    transition: opacity 200ms ease-in;\n  }\n\n  &.fade-exit {\n    opacity: 1;\n  }\n\n  &.fade-exit-done,\n  &.fade-exit.fade-exit-active {\n    opacity: 0.01;\n    transition: opacity 200ms ease-out;\n  }\n"])));
};
export var slide = function slide() {
  return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &.slide-enter,\n  &.slide-appear {\n    max-height: 0px;\n    opacity: 0.01;\n  }\n\n  &.slide-enter-done,\n  &.slide-appear-done,\n  &.slide-enter.slide-enter-active,\n  &.slide-appear.slide-appear-active {\n    opacity: 1;\n    max-height: 2000px;\n    transition: all 200ms;\n  }\n\n  &.slide-exit {\n    opacity: 1;\n    max-height: 2000px;\n  }\n\n  &.slide-exit-done,\n  &.slide-exit.slide-exit-active {\n    max-height: 0px;\n    opacity: 0.01;\n    transition: all 200ms;\n  }\n"], ["\n  &.slide-enter,\n  &.slide-appear {\n    max-height: 0px;\n    opacity: 0.01;\n  }\n\n  &.slide-enter-done,\n  &.slide-appear-done,\n  &.slide-enter.slide-enter-active,\n  &.slide-appear.slide-appear-active {\n    opacity: 1;\n    max-height: 2000px;\n    transition: all 200ms;\n  }\n\n  &.slide-exit {\n    opacity: 1;\n    max-height: 2000px;\n  }\n\n  &.slide-exit-done,\n  &.slide-exit.slide-exit-active {\n    max-height: 0px;\n    opacity: 0.01;\n    transition: all 200ms;\n  }\n"])));
};
export var zoomIn = function zoomIn() {
  return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  &.zoom-in-enter,\n  &.zoom-in-appear {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n\n  &.zoom-enter-done,\n  &.zoom-appear-done,\n  &.zoom-in-enter.zoom-in-enter-active,\n  &.zoom-in-appear.zoom-in-appear-active {\n    opacity: 1;\n    transform: scale3d(1, 1, 1);\n    transition: opacity 100ms ease-out, transform 200ms ease-out;\n  }\n\n  &.zoom-in-exit {\n    opacity: 1;\n    transform: scale3d(1, 1, 1);\n  }\n\n  &.zoom-exit-done,\n  &.zoom-in-exit.slide-exit-active {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n    transition: opacity 200ms ease-out, transform 100ms ease-out;\n  }\n"], ["\n  &.zoom-in-enter,\n  &.zoom-in-appear {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n\n  &.zoom-enter-done,\n  &.zoom-appear-done,\n  &.zoom-in-enter.zoom-in-enter-active,\n  &.zoom-in-appear.zoom-in-appear-active {\n    opacity: 1;\n    transform: scale3d(1, 1, 1);\n    transition: opacity 100ms ease-out, transform 200ms ease-out;\n  }\n\n  &.zoom-in-exit {\n    opacity: 1;\n    transform: scale3d(1, 1, 1);\n  }\n\n  &.zoom-exit-done,\n  &.zoom-in-exit.slide-exit-active {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n    transition: opacity 200ms ease-out, transform 100ms ease-out;\n  }\n"])));
};
var templateObject_1, templateObject_2, templateObject_3;